import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { map, filter, scan, catchError, take, concatMap } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class NotAuthorizedErrorService {
  /**
   * @ignore
   */
  constructor() { }

  /**
   * Not authorized error
   * @param errorCode 
   * @returns authorized error 
   */
  notAuthorizedError(errorCode): string {
    let message = "There is a conflict.";

    let errors = Object.keys(NotAuthorizedError).map(key => NotAuthorizedError[key]);

    if (errors.some(e => e[0] === errorCode)) {
      let err = errors.find(e => e[0] === errorCode);
      message = err[1];
    }

    return message;
  }

}
/**
 * @ignore
 */
export const NotAuthorizedError = {
  ERROR_NOT_AUTHORIZED: {},
  ERROR_NOT_AUTHORIZED_INVALID_TOKEN: {}
}


NotAuthorizedError.ERROR_NOT_AUTHORIZED = [4010000, 'Not Authorized'];
NotAuthorizedError.ERROR_NOT_AUTHORIZED_INVALID_TOKEN = [4010001, 'Invalid token'];